/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo, useState } from 'react'
import { useThree } from '@react-three/fiber';

import { const_var, params } from '../../../../../../../../redux/reducers/reducer';

import { delModel, extrudeSettings, roofPattern, textureAnisotropy } from '../../../../../../../../utils/Functions';
import { CSG } from '../../../../../../../../assets/libs/csg-lib';
import { MaterialInnerWall, MaterialOuterWallNew, MaterialWainScotWallNew } from '../../../../../../CustomMaterial';
import { getSimilarTexture, textureAppliedFor } from '../../../../../../../../redux/reducers/utils';

const WallModel = () => {    
    const { gl } = useThree ();

    const [isStorageSideWall, setIsStorageSideWall] = useState(false);

    const cbFrontBackWallOffset = 0.16;
    const wallThickness = 0.005;
    const railWidth = 0.2;

    const canvasElement = document.getElementsByClassName("buildingcanvas")
    const isPattern = (canvasElement != undefined && canvasElement[0]?.clientWidth > 1050 && !params.p_v_w) ? true : false
    
     

    const texture = useMemo(() => {
        if(const_var.metalTexture){
            let texture = const_var.metalTexture.clone();
            textureAnisotropy(gl, texture,1.3, 1.3, (params.p_v_w != true) ? 0 :  Math.PI/-2);    
            return texture
        }else{
            return null
        }
    }, [params.p_v_w,params.wallTexture,const_var.wallTextureObj[params.wallTexture]])

    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,params.fourth_center_cost,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]])

    let offset;
    if(params.leanF_p_d % legDistance === 0) offset = 0.15;
    else offset = 0;

    const wallPosOffset = useMemo(() => {
        if(params.frontLeanStoragePosition > 0 && params.frontLeanStoragePosition !== params.leanF_p_d - parseInt(params.add_storage_front) - railWidth) return railWidth;
        else return 0;
    }, [params.frontLeanStoragePosition, params.leanF_p_d, params.add_storage_front])

    // Storage Right Wall - CSG
    const storageRightWallModelObj = useMemo(() => {
        let mainWall;
        let innerWall;
        let wainscotWall;

        let lengthOffset;
        if(params.frontLeanStoragePosition === params.leanF_p_d - parseInt(params.add_storage_front) - railWidth) lengthOffset = 0.12;
        else lengthOffset = 0;
        
        //************************* */ main wall geometry
        let verticalHorizontalPosStorageS = {"x": -params.leanF_p_d / 2 + parseInt(params.add_storage_front) + offset + wallPosOffset,"y" : (params.p_w_c_n ? 2.935 : 0), "z" : params.p_d / 2 + 0.22}
        let verticalHorizontalRotStorageS = {"x":0,"y" : Math.PI / -2,"z" : Math.PI / 2}
        let patternLengthStorageS = params.leanF_p_h + ((params.b_l_t_r_pF/12) * params.leanF_p_w) + (params.p_w_c_n ? -2.935 : 0) + (params.p_r_s === 1 ? const_var.roofRegularDst * 2 : 0)
        let patternDepthStorageS = parseInt(params.add_storage_front) + offset + wallPosOffset

        const storageSideWallModel = new THREE.Shape();
        storageSideWallModel.moveTo(-params.leanF_p_d / 2 + wallThickness, 0);
        storageSideWallModel.lineTo(-params.leanF_p_d / 2 + wallThickness, params.leanF_p_h + (params.leanF_p_w - 0.05) * params.b_l_t_r_pF / 12 + (params.p_r_s === 1 ? const_var.roofRegularDst * 2 : 0));
        storageSideWallModel.lineTo(-params.leanF_p_d / 2 + parseInt(params.add_storage_front) + offset + (params.frontLeanStoragePosition > 0 && cbFrontBackWallOffset), params.leanF_p_h + (params.leanF_p_w - 0.05) * params.b_l_t_r_pF / 12 + (params.p_r_s === 1 ? const_var.roofRegularDst * 2 : 0));
        storageSideWallModel.lineTo(-params.leanF_p_d / 2 + parseInt(params.add_storage_front) + offset + (params.frontLeanStoragePosition > 0 && cbFrontBackWallOffset), 0);
        storageSideWallModel.closePath();

        const meshSideStorageWallModelPattern = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLengthStorageS, isPattern), extrudeSettings(patternDepthStorageS)));
        const meshFrontStorageInnerWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(storageSideWallModel, extrudeSettings(wallThickness)), new THREE.MeshStandardMaterial({ color: 'brown' }))
        const meshFrontStorageInDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('frontLeanStorageRight', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
    
        let meshStorageWallModel_TempS = meshSideStorageWallModelPattern.clone();
        meshStorageWallModel_TempS.position.set(verticalHorizontalPosStorageS.x,verticalHorizontalPosStorageS.y,verticalHorizontalPosStorageS.z);
        meshStorageWallModel_TempS.rotation.set(verticalHorizontalRotStorageS.x,verticalHorizontalRotStorageS.y,verticalHorizontalRotStorageS.z);
        meshStorageWallModel_TempS.updateMatrixWorld();
        
        let meshFrontStorageInnerWallModel_Temp = meshFrontStorageInnerWallModel.clone();
        meshFrontStorageInnerWallModel_Temp.position.set(0, 0, params.p_d / 2 + cbFrontBackWallOffset + 0.07)
        meshFrontStorageInnerWallModel_Temp.updateMatrixWorld()

        let meshFrontStorageInDelModel_Temp = meshFrontStorageInDelModel.clone();
        meshFrontStorageInDelModel_Temp.position.set(-params.leanF_p_pos - params.frontLeanStoragePosition, 0, params.p_d / 2 + 0.5)
        meshFrontStorageInDelModel_Temp.rotateY(-Math.PI)
        meshFrontStorageInDelModel_Temp.updateMatrixWorld()
    
        const meshFrontStorageInnerWallModel_CSG = CSG.fromMesh(meshFrontStorageInnerWallModel_Temp);
        const meshFrontStorageInDelModel_CSG = CSG.fromMesh(meshFrontStorageInDelModel_Temp);
        const meshStorageWallModel_CSGS = CSG.fromMesh(meshStorageWallModel_TempS);
    
        const storageSideWallModel_CSG = meshStorageWallModel_CSGS.subtract(meshFrontStorageInDelModel_CSG);
        const frontStorageInnerWallModel_CSG =  meshFrontStorageInnerWallModel_CSG.subtract(meshFrontStorageInDelModel_CSG);
       
        const CSGFrontStorageOuterWallModel = CSG.toMesh(storageSideWallModel_CSG, new THREE.Matrix4(), new THREE.MeshStandardMaterial({ color: 'blue' }))
        const CSGFrontStorageInnerWallModel = CSG.toMesh(frontStorageInnerWallModel_CSG, new THREE.Matrix4(), new THREE.MeshStandardMaterial({ color: 'blue' }))

        mainWall = CSGFrontStorageOuterWallModel.geometry;
        innerWall = CSGFrontStorageInnerWallModel.geometry
        
        //************************* */ wainscot wall geometry
        let wainscotVerticalHorizontalPosStorageS = {"x": -params.leanF_p_d / 2 + parseInt(params.add_storage_front) + offset + wallPosOffset,"y" : 0, "z" : params.p_d / 2 + 0.22}
        let wainscotVerticalHorizontalRotStorageS = {"x":0,"y" : Math.PI / -2,"z" : Math.PI / 2}
        let lengthPatternStorageS = 3
        let depthPatternStorageS = patternDepthStorageS
    
        const meshStorageRightWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPatternStorageS, isPattern), extrudeSettings(depthPatternStorageS)));

        let meshStorageRightWainscotModel_Temp = meshStorageRightWainscotModel.clone();
        meshStorageRightWainscotModel_Temp.position.set(wainscotVerticalHorizontalPosStorageS.x,wainscotVerticalHorizontalPosStorageS.y,wainscotVerticalHorizontalPosStorageS.z);
        meshStorageRightWainscotModel_Temp.rotation.set(wainscotVerticalHorizontalRotStorageS.x,wainscotVerticalHorizontalRotStorageS.y,wainscotVerticalHorizontalRotStorageS.z);
        meshStorageRightWainscotModel_Temp.updateMatrixWorld();
    
        const meshStorageRightWainscotModel_CSG = CSG.fromMesh(meshStorageRightWainscotModel_Temp);
    
        const frontStorageInWallModelCSG = meshStorageRightWainscotModel_CSG.subtract(meshFrontStorageInDelModel_CSG);
        const CSGStorageRightWainscotModel = CSG.toMesh( frontStorageInWallModelCSG, new THREE.Matrix4())

        wainscotWall = CSGStorageRightWainscotModel.geometry;

        return {mainWall, innerWall, wainscotWall}    

    }, [params.wallTexture,params.p_d, params.leanF_p_w, wallPosOffset, params.leanF_p_d, params.frontLeanStoragePosition, params.leanF_p_h, params.b_l_t_r_pF, params.p_w_c_n, params.p_v_w, params.add_storage_front, const_var.newDoorsArray, params.add_storage_check_front, params.leanF_p_pos, params.p_r_s])

    useMemo(() => {
        let array = const_var.newDoorsArray.filter((item) => item.userData.wallName === 'c_b_f_w' && item.height > params.leanF_p_h);
        for(let i=0; i<array.length; i++) {
            let item = array[i];
            const doorPositionX = item.positionX;
            const doorWidth = item.width
            const LeftStoragePos = params.leanF_p_pos - params.leanF_p_d / 2
            const RightStoragePos = params.leanF_p_pos - params.leanF_p_d / 2 + parseInt(params.add_storage_front)
            if((LeftStoragePos >= (doorPositionX - doorWidth / 2)) && (RightStoragePos <= (doorPositionX + doorWidth / 2))){
                setIsStorageSideWall(true)
                return;
            } 
            setIsStorageSideWall(false)
        }
        if(array.length == 0) setIsStorageSideWall(false)

    }, [const_var.newDoorsArray, params.leanF_p_pos, params.leanF_p_d, params.add_storage_front, params.leanF_p_h])

    return (
        <>
        {/* <primitive object={meshStorageWallModel_TempS}/> */}
            {storageRightWallModelObj?.mainWall && !isStorageSideWall && 
                <mesh name="F_L_B_S_W" geometry={storageRightWallModelObj?.mainWall} >
                    <MaterialOuterWallNew isPattern={isPattern}     visibleSection={"frontLean"} />
                </mesh>
            }
            {storageRightWallModelObj?.innerWall &&
                <mesh name="storage-right" geometry={storageRightWallModelObj?.innerWall} position={[0, 0, wallThickness + 0.01]}>
                    <MaterialInnerWall texture={texture} visibleSection={"frontLean"} />
                </mesh>
            }
            {/* Storage Right Side Wainscot */}
            {params.p_w_c_n === true && storageRightWallModelObj?.wainscotWall &&
                <mesh name="F_L_F_S_W_wainscot" geometry={storageRightWallModelObj?.wainscotWall} position={[0,0,-0.005]}>
                    <MaterialWainScotWallNew isPattern={isPattern}     visibleSection={"frontLean"} />
                </mesh>
            }
        </>
    )
}

export default WallModel